import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';

//MyPecrDropdown to show as My P/ECR drop-down on nav-bar
const MyPecrDropdown = props => {
  const { navigate, location } = props;
  const { t } = useTranslation();

  const pathParts = window.location.toString().split('/');
  const linkText = pathParts.pop();
  const listBookmark = pathParts.pop();

  const isMyPecrRoute =
    linkText === 'MyPecr' ||
    linkText === 'owner' ||
    linkText === 'creator' ||
    linkText === 'actor' ||
    listBookmark === 'MyPecr';

  //Custom style for drop-down
  const Styles = {
    control: styles => {
      return {
        ...styles,
        backgroundColor: 'transparent',
        border: 'none',
        // This line disables the blue border
        boxShadow: 'none',
        cursor: 'pointer',
        padding: 0,
      };
    },
    menu: defaultStyles => {
      return {
        ...defaultStyles,
        width: '220px',
      };
    },
    dropdownIndicator: defaultStyles => {
      return {
        ...defaultStyles,
        position: 'relative',
        right: '8px',
        padding: 0,
      };
    },
    placeholder: defaultStyles => {
      return {
        ...defaultStyles,
        color: isMyPecrRoute ? 'white' : 'rgba(255,255,255,.55)',
      };
    },
  };

  //options for drop-down
  const myPecrOptions = [
    {
      label: t('All'),
      value: 'all',
    },
    {
      label: t('Owner'),
      value: 'owner',
    },
    {
      label: t('Creator'),
      value: 'creator',
    },
    {
      label: t('Actor'),
      value: 'actor',
    },
  ];

  //To handle the onchange of drop-down
  const handleChange = event => {
    if (event.value === 'all') {
      navigate({ pathname: '/MyPecr', search: location.search });
      return;
    }

    navigate({ pathname: `/MyPecr/${event.value}`, search: location.search });
  };

  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <ArrowDropDownIcon
          style={{
            color: isMyPecrRoute ? 'white' : 'rgba(255,255,255,.55)',
            fontSize: 40,
          }}
        />
      </components.DropdownIndicator>
    );
  };

  return (
    <Select
      onChange={handleChange}
      options={myPecrOptions}
      styles={Styles}
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator,
      }}
      value={t('My_PECR')}
      placeholder={t('My_PECR')}
      isSearchable={false}
    />
  );
};

export default MyPecrDropdown;
